<div data-test="small-screen-warning" class="small-screen-warning">
  <p>
    Please be aware, this application may not perform properly on this screen
    size. Please use a larger device for the best experience.
  </p>
</div>

@if (authenticatedView) {
  <mat-sidenav-container autosize class="monek-page-container">
    <mat-sidenav #sidenav [mode]="sidebarMode" [opened]="burgerMenuOpen" class="monek-mat-sidenav border-end-0 bg-dark-always">
      <div class="monek-sidenav overflow-hidden h-100">
        <div class="sidebar-header h-100" style="min-height: 73px; max-height: 73px;">
          <div class="monek-logo d-flex justify-center align-items-center">
            <img class="monek-logo-image me-1"
              [ngStyle]="{'max-width': bhelper.currentBranding().logoWidth, 'max-height': bhelper.currentBranding().logoHeight }"
              [src]="bhelper.currentBranding().logoUrl" />
            @if (bhelper.currentBranding().hasTextLogo) {
              <span class="{{bhelper.currentBranding().textLogoClass}} monek-logo-text mon-text-white">{{bhelper.currentBranding().brandName}}</span>
            }
          </div>
        </div>
        <div class="monek-navigation px-2" style="max-height: calc(100dvh - 73px - 52px); overflow: auto; direction: rtl;">
          <div style="direction: ltr;">
            @for (navRoute of navigationService.navigationRoutes; track navRoute.safeRoute) {
              @if (navRoute.enabled && navRoute.hasVisiblesubRoutes()) {
                <div [attr.data-test]="navRoute.safeRoute"
                  [attr.data-test-url]="navRoute | json"
                  class="monek-nav-button mb-2 rounded-pill contrast-hover" [class.odin-active]="navRoute.active"
                     [class.odin-active-sub-route]="navRoute.hasActiveSubRoute()"
                  [class.fw-bold]="navRoute.hasActiveSubRoute()" (click)="navigate(navRoute)">
                  <div class="monek-nav-button-icon">
                    <fa-icon [icon]="navRoute.icon" size="lg"></fa-icon>
                  </div>
                  <p class="w-100 d-block text-start flex-1">{{ navRoute.viewName }}</p>
                  <div class="monek-nav-button-icon align-self-end">
                    @if (navRoute.hasSubRoutes()) {
                      <fa-icon [icon]="
                            navRoute?.advanced?.opened || navRoute.hasActiveSubRoute()
                              ? ddOpen
                              : ddClosed
                        " size="lg"></fa-icon>
                    }
                  </div>
                </div>
              }

              @if (navRoute.hasSubRoutes() && (navRoute?.advanced?.opened || navRoute.hasActiveSubRoute())) {
                <div>
                  @for (subRoute of navRoute?.advanced?.subRoutes; track subRoute.safeRoute) {
                    @if (subRoute.enabled) {
                      <div [attr.data-test]="subRoute.safeRoute"
                        class="monek-nav-button mb-2 rounded-pill contrast-hover" [class.odin-active]="subRoute.active"
                        [attr.data-test-url]="subRoute | json"
                        (click)="navigate(subRoute)">
                        <div class="d-flex justify-content-center align-items-center w-100">
                          <div class="monek-nav-button-icon">
                            <!-- <fa-icon [icon]="ddOption"></fa-icon> -->
                          </div>
                          <div class="d-flex justify-content-start align-items-center flex-fill" style="margin-left: 16px">
                            <div class="monek-nav-button-icon">
                              <fa-icon [icon]="subRoute.icon" size="lg"></fa-icon>
                            </div>
                            <p class="pe-0">{{ subRoute.viewName }}</p>
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>
        </div>
        <!-- Remove to center nav -->
        <div style="flex: 1 1 auto"></div>

        <!-- Mobile: full-width merchant picker button -->
        <div class="not-desktop sidebar-bottom-picker">
          <odin-merchant-picker [dropUp]="true"></odin-merchant-picker>
        </div>

        <!-- Desktop: version number -->
        <div class="py-3 monek-sidenav-info dark-panel desktop-only" 
          [attr.data-test]="'version-number'">
          <p>{{ versionNumber | slice: 0 : 11 }}</p>
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="monek-page-content app-page-container">
      <div class="site-container">
        <div class="mobile-header bg-dark-always mon-text-white">
          <div class="header-actions">
            <div id="burger-open" class="not-desktop">
              <button mat-icon-button (click)="sidenav.open()" data-test="app-page-container-sidenav-open-button">
                <fa-icon [icon]="menuIcon"></fa-icon>
              </button>
            </div>
            <div class="ms-1" id="page-title">
              <p>{{ navigationService.currentRoute.viewName }}</p>
            </div>
          </div>
          <div class="flex-space"></div>
          <div class="header-actions">

            <button mat-icon-button aria-label="notifications" matTooltip="Notifications" [routerLink]="['/notifications']" data-test="header-notification">
              <mat-icon [fontIcon]="hasUnreadNotifications ? 'notifications_active' : 'notifications'"></mat-icon>
            </button>

            <mat-divider [vertical]="true" class="header-divider"></mat-divider>

            <button mat-icon-button (click)="ToggleLightDark()" [attr.aria-label]="lightMode ? 'Switch to dark mode' : 'Switch to light mode'" matTooltip="{{ lightMode ? 'Switch to dark mode' : 'Switch to light mode' }}" data-test="app-page-container-toggle-light-dark-button">
              <mat-icon [ngClass]="{ 'mon-text-white': !lightMode, 'text-warning': lightMode }">{{ lightMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
            </button>

            <odin-merchant-picker class="desktop-only"></odin-merchant-picker>
            <!-- user icon -->
            @if (user_information$ | async; as user) {
              <div id="user-details">
                <img src="{{ user.user_picture }}" [matMenuTriggerFor]="userMenu" [matMenuTriggerData]="{ data: user }" />
              </div>
            }
          </div>
        </div>
        <div class="app-page-container app-content-container page-height bg-dark-always">
          <div style="box-shadow: 10px 10px 12px 0px rgba(0,0,0,0.17) inset;" class="main-panel h-100 page-height router-container">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  @if (!loggingOut) {
    <div class="app-page-container not-logged-in app-content-container">
      <router-outlet></router-outlet>
    </div>
  }
}

<mat-menu #userMenu="matMenu">
  <ng-template matMenuContent let-aliasMenuItems="data">
    <p mat-menu-item>
      <span>{{ aliasMenuItems.user_full_name }}</span>
    </p>
    <p mat-menu-item>
      <span>{{ aliasMenuItems.user_email }}</span>
    </p>
  </ng-template>
</mat-menu>